"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reselect = require("reselect");

// Each action includes the root state, minus some non-essential stuff, so we
// can use selectors within reducers.
exports.default = (0, _reselect.createStructuredSelector)({
  firebase: (0, _reselect.createStructuredSelector)({
    auth: function auth(root) {
      return root.firebase.auth;
    },
    data: (0, _reselect.createStructuredSelector)({
      options: function options(root) {
        return root.firebase.data.options;
      },
      roles: function roles(root) {
        return root.firebase.data.roles;
      }
    })
  }),
  firebaseAuthLoaded: function firebaseAuthLoaded(root) {
    return root.firebaseAuthLoaded;
  },
  entities2: function entities2(root) {
    return root.entities2;
  }
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZmlyZWJhc2UvY2hhcmFjdGVyczIvY2FjaGVhYmxlLXJvb3QuanMiXSwibmFtZXMiOlsiZmlyZWJhc2UiLCJhdXRoIiwicm9vdCIsImRhdGEiLCJvcHRpb25zIiwicm9sZXMiLCJmaXJlYmFzZUF1dGhMb2FkZWQiLCJlbnRpdGllczIiXSwibWFwcGluZ3MiOiI7Ozs7OztBQUNBOztBQUVBO0FBQ0E7a0JBQ2Usd0NBQXlCO0FBQ3RDQSxZQUFVLHdDQUF5QjtBQUNqQ0MsVUFBTTtBQUFBLGFBQVFDLEtBQUtGLFFBQUwsQ0FBY0MsSUFBdEI7QUFBQSxLQUQyQjtBQUVqQ0UsVUFBTSx3Q0FBeUI7QUFDN0JDLGVBQVM7QUFBQSxlQUFRRixLQUFLRixRQUFMLENBQWNHLElBQWQsQ0FBbUJDLE9BQTNCO0FBQUEsT0FEb0I7QUFFN0JDLGFBQU87QUFBQSxlQUFRSCxLQUFLRixRQUFMLENBQWNHLElBQWQsQ0FBbUJFLEtBQTNCO0FBQUE7QUFGc0IsS0FBekI7QUFGMkIsR0FBekIsQ0FENEI7QUFRdENDLHNCQUFvQjtBQUFBLFdBQVFKLEtBQUtJLGtCQUFiO0FBQUEsR0FSa0I7QUFTdENDLGFBQVc7QUFBQSxXQUFRTCxLQUFLSyxTQUFiO0FBQUE7QUFUMkIsQ0FBekIsQyIsImZpbGUiOiJjYWNoZWFibGUtcm9vdC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQge2NyZWF0ZVN0cnVjdHVyZWRTZWxlY3Rvcn0gZnJvbSBcInJlc2VsZWN0XCJcblxuLy8gRWFjaCBhY3Rpb24gaW5jbHVkZXMgdGhlIHJvb3Qgc3RhdGUsIG1pbnVzIHNvbWUgbm9uLWVzc2VudGlhbCBzdHVmZiwgc28gd2Vcbi8vIGNhbiB1c2Ugc2VsZWN0b3JzIHdpdGhpbiByZWR1Y2Vycy5cbmV4cG9ydCBkZWZhdWx0IGNyZWF0ZVN0cnVjdHVyZWRTZWxlY3Rvcih7XG4gIGZpcmViYXNlOiBjcmVhdGVTdHJ1Y3R1cmVkU2VsZWN0b3Ioe1xuICAgIGF1dGg6IHJvb3QgPT4gcm9vdC5maXJlYmFzZS5hdXRoLFxuICAgIGRhdGE6IGNyZWF0ZVN0cnVjdHVyZWRTZWxlY3Rvcih7XG4gICAgICBvcHRpb25zOiByb290ID0+IHJvb3QuZmlyZWJhc2UuZGF0YS5vcHRpb25zLFxuICAgICAgcm9sZXM6IHJvb3QgPT4gcm9vdC5maXJlYmFzZS5kYXRhLnJvbGVzLFxuICAgIH0pLFxuICB9KSxcbiAgZmlyZWJhc2VBdXRoTG9hZGVkOiByb290ID0+IHJvb3QuZmlyZWJhc2VBdXRoTG9hZGVkLFxuICBlbnRpdGllczI6IHJvb3QgPT4gcm9vdC5lbnRpdGllczIsXG59KVxuIl19


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/firebase/characters2/cacheable-root.js
// module id = 359
// module chunks = 0